export const BREAKPOINTS = {
  tiny: '400px',
  small: '600px',
  medium: '800px',
  large: '1100px',
  xxLarge: '1400px',
}
